exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.login-title {\n  margin-top: 100px;\n  margin-bottom: 15%;\n  display: inline-block;\n}\n", "", {"version":3,"sources":["/home/runner/work/health-frontend/health-frontend/src/templates/src/templates/LoginPage.vue"],"names":[],"mappings":";AAoBA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;CACA","file":"LoginPage.vue","sourcesContent":["<template>\n  <section>\n    <div class=\"login-title\">\n      <img class=\"title\" src=\"@/assets/top/LASHIC_healthlab_logo.png\" width=\"1880\" height=\"203\" loading=\"lazy\"/>\n    </div>\n      <LoginForm />\n  </section>\n</template>\n\n<script>\nimport LoginForm from '@/organisms/LoginForm.vue'\nexport default {\n\n  components: {\n    LoginForm\n  },\n};\n</script>\n\n<style>\n.login-title {\n  margin-top: 100px;\n  margin-bottom: 15%;\n  display: inline-block;\n}\n</style>"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a3ba6d9","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/templates/LoginPage.vue
// module id = 7XUg
// module chunks = 1